// PaymentSuccess.js (v2 Orders API)

import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Typography, CircularProgress, Box, Button, Paper, List, ListItem, Divider } from '@mui/material';
import { post_auth } from './auth';
import { serverUrl } from './ConfigHolder';

const PaymentDetails = ({ paymentData }) => {
  const {
    id,
    status,
    payer,
    purchase_units
  } = paymentData;

  const capture = purchase_units?.[0]?.payments?.captures?.[0];

  return (
    <Paper elevation={3} sx={{ padding: 2 }}>
      <Typography variant="h4" gutterBottom>Receipt</Typography>
      <Typography variant="subtitle1">Order ID: {id}</Typography>
      <Typography variant="subtitle1">Status: {status}</Typography>
      {capture && (
        <>
          <Typography variant="subtitle1">
            Captured: {new Date(capture.update_time).toLocaleString()}
          </Typography>
          <Typography variant="subtitle1">
            Amount: {capture.amount.value} {capture.amount.currency_code}
          </Typography>
          <Typography variant="subtitle1">
            Transaction ID: {capture.id}
          </Typography>
        </>
      )}

      <Divider sx={{ my: 2 }} />

      {payer && (
        <>
          <Typography variant="h5" gutterBottom>Payer Information</Typography>
          <List dense>
            <ListItem>
              <Typography variant="subtitle1">
                Name: {payer.name?.given_name} {payer.name?.surname}
              </Typography>
            </ListItem>
            <ListItem>
              <Typography variant="subtitle1">
                Email: {payer.email_address}
              </Typography>
            </ListItem>
          </List>
        </>
      )}
    </Paper>
  );
};

function PaymentSuccess() {
  let [searchParams] = useSearchParams();
  const [paymentData, setPaymentData] = useState(null);
  const [loading, setLoading] = useState(false);

  // Extract orderId from redirect URL (PayPal sends it as token)
  const orderId = searchParams.get('token');

  useEffect(() => {
    const capturePayment = async () => {
      if (orderId) {
        setLoading(true);
        try {
          const uri = `${serverUrl}/capture_paypal_order`;
          const response = await post_auth(uri, { orderId });
          setPaymentData(response.data);
        } catch (error) {
          console.error("Error capturing PayPal order:", error);
        } finally {
          setLoading(false);
        }
      }
    };
    capturePayment();
  }, [orderId]);

  return (
    <div>
      <Box>
        {loading ? (
          <Box display="flex" justifyContent="center">
            <CircularProgress />
          </Box>
        ) : (
          <Box>
            <Typography variant="body1" gutterBottom>
              {!paymentData && 'Waiting for payment details...'}
            </Typography>

            {paymentData && <PaymentDetails paymentData={paymentData} />}

            <Button
              variant="contained"
              color="primary"
              sx={{ mt: 2 }}
              onClick={() => (window.location.href = '/')}
            >
              Continue
            </Button>
          </Box>
        )}
      </Box>
    </div>
  );
}

export default PaymentSuccess;
// JustPayment.js (v2 Orders API)